<!-- About us Start -->
<section class="section why-choose-us" id="about"
  style="background: url('../../../assets//images/why-choose-us.png'), #6320CE; background-size: cover;">
  <div class="" style="width: 100%; display:flex;justify-content:center;">
    <div class="absolute">
      <img src="/assets/images/transition-pattern.png" class="img-responsive relative" />
    </div>
  </div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-6 col-md-8">
        <div class="title text-center mb-5">
          <h1 class="font-weight-normal text-white">WHY CHOOSE US ?</h1>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- About us End -->
